var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8086 0.779297C5.28859 0.779297 0.808594 5.2593 0.808594 10.7793C0.808594 16.2993 5.28859 20.7793 10.8086 20.7793C16.3286 20.7793 20.8086 16.2993 20.8086 10.7793C20.8086 5.2593 16.3286 0.779297 10.8086 0.779297ZM13.3485 9.82935L13.1786 11.2192C13.1686 11.3492 13.0486 11.4592 12.9186 11.4492H11.4685V15.5793C11.4685 15.6793 11.3886 15.7693 11.2886 15.7693H9.81848C9.71848 15.7693 9.62855 15.6793 9.63855 15.5793V11.4492H8.53857C8.38857 11.4492 8.27856 11.3292 8.27856 11.1892V9.79932C8.27856 9.64932 8.39857 9.53931 8.53857 9.53931H9.62854V8.18921C9.62854 6.62921 10.5586 5.7793 11.9186 5.7793H13.0286C13.1786 5.7793 13.2886 5.89931 13.2886 6.03931V7.20923C13.2886 7.35923 13.1686 7.46924 13.0286 7.46924H12.3485C11.6085 7.47924 11.4685 7.83938 11.4685 8.35938V9.51929H13.0885C13.2385 9.51929 13.3485 9.63931 13.3485 9.78931C13.3485 9.78931 13.3485 9.80934 13.3485 9.81934V9.82935Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSmallLogo);
export default __webpack_public_path__ + "static/media/facebookSmallLogo.0da8972ae5ec798d8fead66082a64fca.svg";
export { ForwardRef as ReactComponent };